import RouteView from '@/router/RouteView.vue';
// import MyClass from './index.vue'; // 已购课程
import MyClass from '../MyCourse/packageList/index.vue'; // 我的课程
import ClassDetail from '../Goods/ClassDetail/index.vue'; // 课程详情
import MyOrder from './MyOrder/index.vue'; // 我的订单

import GoodsTimeStatistics from '../CourseDistribution/goodsTimeStatistics.vue'; // 耗课统计

import MyCreate from './MyCreate/index.vue'; // 上课
import MyClasses from './MyClasses/index.vue'; // 班级
import MyRecord from './MyRecord/index.vue'; // 上课记录

export default [
  {
    path: '/myClass',
    name: 'myClass',
    component: MyClass,
    meta: {
      title: '我的课程',
    },
  },
  {
    path: '/myClass',
    component: RouteView,
    meta: {
      title: '我的课程',
    },
    children: [
      {
        path: '/myClass/classDetail',
        name: 'classDetail',
        component: ClassDetail,
        meta: {
          title: '课程详情',
        },
      },
      {
        path: '/myClass/myOrder',
        name: 'myOrder',
        component: MyOrder,
        meta: {
          title: '我的订单',
        },
      },
      {
        path: '/myClass/myOrder',
        component: RouteView,
        meta: {
          title: '我的订单',
        },
        children: [
          {
            path: '/myClass/myOrder/timeStatistics',
            name: 'timeStatistics',
            component: GoodsTimeStatistics,
            meta: {
              title: '耗课记录',
            },
          },
        ],
      },
      {
        path: '/myClass/myCreate',
        name: 'myCreate',
        component: MyCreate,
        meta: {
          title: '上课',
        },
      },
      {
        path: '/myClass/myCreate',
        component: RouteView,
        meta: {
          title: '上课',
        },
        children: [
          {
            path: '/myClass/myCreate/myClasses',
            name: 'myClasses',
            component: MyClasses,
            meta: {
              title: '班级',
            },
          },
        ],
      },
      {
        path: '/myClass/myRecord',
        name: 'myRecord',
        component: MyRecord,
        meta: {
          title: '上课记录',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/MyClass/router.js